import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmPopupProps } from './types';
import ConfirmationModal from './ConfirmationModal';

/**
 * Confirmation popup for Custom Module / Control Library actions, rendered on the
 * master-design `ConfirmationModal` chrome. Callers handle the actual action in `onConfirm`.
 * @param props - open state, title, message, close and confirm handlers, optional button label and colour.
 * @returns the confirmation modal.
 */
const ConfirmPopup: React.FC<ConfirmPopupProps> = ({ onOpen, title, message, toggle, onConfirm, confirmLabel, confirmVariant = 'red' }) => {
  const { t } = useTranslation('common');

  return (
    <ConfirmationModal
      show={onOpen}
      title={title}
      message={message}
      onClose={toggle}
      onConfirm={onConfirm}
      confirmLabel={confirmLabel ?? t('COMMON_LABEL.YES')}
      confirmVariant={confirmVariant}
    />
  );
};

export default ConfirmPopup;
